import { render } from "./TrendsResults.vue?vue&type=template&id=538820be&scoped=true"
import script from "./TrendsResults.vue?vue&type=script&lang=js"
export * from "./TrendsResults.vue?vue&type=script&lang=js"

import "./TrendsResults.vue?vue&type=style&index=0&id=538820be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538820be"]])

export default __exports__